module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    staticClass: "page messages-page",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [(_vm.$store.state.auth.user) ? _c('v-flex', {
    staticClass: "messages-page-content",
    attrs: {
      "xs12": "",
      "sm10": "",
      "offset-sm1": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [(!_vm.conversations || _vm.conversations.length == 0) ? _c('v-flex', {
    staticClass: "message-rooms-section empty-section",
    attrs: {
      "xs12": "",
      "pa-0": ""
    }
  }, [_c('p', {
    staticClass: "empty-title"
  }, [_vm._v("No messages")]), _vm._v(" "), _c('p', {
    staticClass: "empty-description"
  }, [_vm._v("Conversations will appear here.")])]) : [_c('v-flex', {
    staticClass: "conversations",
    attrs: {
      "xs12": "",
      "sm3": "",
      "pa-0": ""
    }
  }, [_c('div', {
    staticClass: "conversations__header"
  }, [_c('div', {
    staticClass: "conversations__title"
  }, [_vm._v("Inbox")]), _vm._v(" "), _c('div', {
    staticClass: "conversations__count"
  }, [_vm._v("\n              " + _vm._s(_vm.conversations.length) + " messages\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "conversations__content"
  }, _vm._l((_vm.conversations), function(conv) {
    return _c('div', {
      key: ("conversation-" + (conv.id)),
      staticClass: "message-room-item",
      class: {
        new: conv.last_message && !conv.last_message.is_read,
        selected: conv.id == _vm.conversation.id,
      },
      on: {
        "click": function($event) {
          _vm.selectedConversation(conv)
        }
      }
    }, [_c('div', {
      staticClass: "avatar-area"
    }, [_c('router-link', {
      attrs: {
        "to": ("/" + (conv.other.slug))
      }
    }, [(!conv.other.length) ? _c('div', {
      staticClass: "avatar-image",
      style: ('background-image: url(' +
        conv.other.avatar.thumb.url +
        ');')
    }) : _vm._e()])], 1), _vm._v(" "), _c('div', {
      staticClass: "detail-area"
    }, [_c('label', {
      staticClass: "user-name"
    }, [_vm._v(_vm._s(conv.other.username))]), _vm._v(" "), _c('label', {
      staticClass: "short-message"
    }, [_vm._v(_vm._s(conv.last_message.body))])]), _vm._v(" "), _c('label', {
      staticClass: "messaged-time"
    }, [_vm._v(_vm._s(_vm.toLocalTimeString(conv.last_message.created_at)))])])
  }))]), _vm._v(" "), (_vm.conversation && _vm.conversation.id > 0) ? _c('v-flex', {
    staticClass: "message-content-section",
    class: {
      sm6: _vm.currentUser.user_type === 'artist',
      sm9: _vm.currentUser.user_type !== 'artist',
    },
    attrs: {
      "xs12": "",
      "pa-0": ""
    }
  }, [_c('div', {
    staticClass: "header-section"
  }, [_c('p', {
    staticClass: "user-name"
  }, [_vm._v("\n              " + _vm._s(_vm.conversation.other.username) + "\n              "), (_vm.conversation.other.user_type == 'artist') ? _c('v-icon', {
    staticClass: "user-status",
    class: {
      online: _vm.conversation.other.status == 'active'
    }
  }, [_vm._v("fa-check-circle")]) : _vm._e()], 1), _vm._v(" "), _c('p', {
    staticClass: "messaged-time"
  }, [_vm._v("\n              Repost Price: $" + _vm._s(_vm._f("formatNumber")(_vm.conversation.other.repost_price)) + "\n            ")])]), _vm._v(" "), (_vm.messages && _vm.messages.length > 0) ? _c('div', {
    staticClass: "message-list-section"
  }, _vm._l((_vm.messages), function(message) {
    return _c('message', {
      key: message.id,
      attrs: {
        "message": message,
        "is-own": _vm.conversation.other.id != message.sender.id
      },
      on: {
        "updated": _vm.refreshMessages
      }
    })
  })) : _vm._e()]) : _vm._e()]], 2)], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7bfc896e","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/user/direct_messages.vue
// module id = 1793
// module chunks = 180